import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Buttons from '../../../../../../../../components/forms/Buttons';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../../store';
import { Loader, Message } from '@omnigenbiodata/ui';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { resetShipmentConfirmQC, shipmentConfirmQCThunk } from '../../../../../../../../store/shipmentConfirmQC';
import {
  shipmentConfirmQCHasErrorSelector,
  shipmentConfirmQCIsBusySelector,
  shipmentConfirmQCResponseSelector,
} from '../../../../../../../../store/shipmentConfirmQC/selectors';

interface ConfirmQCPassModalProps {
  staged: any | null;
  isOpen: boolean;
  onClose: () => void;
  t: any;
}

const ConfirmQCPassModal = ({ isOpen, onClose, staged, t }: ConfirmQCPassModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const confirmQCIsBusy = useAppSelector(shipmentConfirmQCIsBusySelector);
  const confirmQCResponse = useAppSelector(shipmentConfirmQCResponseSelector);
  const confirmQCError = useAppSelector(shipmentConfirmQCHasErrorSelector);

  const onConfirm = () => {
    dispatch(shipmentConfirmQCThunk());
  };

  useEffect(() => {
    if (confirmQCResponse && confirmQCResponse.stagedShipmentMetaUuid) {
      dispatch(resetShipmentConfirmQC());

      console.log('confirmQCResponse==', confirmQCResponse);
      onClose();
    }
  }, [dispatch, confirmQCResponse, navigate, onClose]);

  return (
    <Dialog
      open={isOpen}
      maxWidth="md"
      fullWidth
      onClose={onClose}
      aria-labelledby="shipping-confirm-modal"
      data-testid="shipping-confirm-modal"
    >
      <DialogTitle id="end-dialog-title">
        <Typography my={1} variant="h4" component="div" align="center">
          {t('QCShipment.confirm.title')}
        </Typography>
        <Typography variant="body1" align="center">
          {t('QCShipment.confirm.text', {
            sampleTotal: staged ? staged.totalAliquotCount : 0,
            boxTotal: staged ? staged.cryoboxes.length : 0,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Container maxWidth="sm">
          {confirmQCError.hasError && <Message severity="error">{confirmQCError.message}</Message>}
        </Container>
        <Loader
          data-testid="manifest-message"
          isVisible={confirmQCIsBusy}
          label={t('loaders.confirmQCPass') as string}
        />
      </DialogContent>
      <DialogActions>
        <Box px={2} pb={2} width="100%">
          <Buttons
            forwardLabel={t('buttons.confirm')}
            onForward={onConfirm}
            onBack={onClose}
            backLabel={t('buttons.cancel')}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmQCPassModal;
